var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"applets"},[_c('div',{staticClass:"applets-pic"},[_c('p',{staticClass:"head-title"},[_vm._v("客服微信")]),_c('img',{attrs:{"src":require("../assets/kefu.png"),"alt":""}}),_c('p',{staticClass:"foot-title"},[_vm._v("扫码添加")])])])
}]

export { render, staticRenderFns }